// stages/FileUploadStage.js
import React from 'react';

const FileUploadStage = ({ 
  handleDrop, 
  handleDragOver, 
  fileInputRef, 
  handleFileUpload, 
  isAnalyzing 
}) => {
  return (
    <div className="stage">
      <h2 className="stage-title">Step 1: Upload Your File</h2>
      <div
        className="upload-area"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={() => fileInputRef.current?.click()}
      >
        <div className="upload-icon">📊</div>
        <h3>Drop your Excel file here or click to browse</h3>
        <p>Supports .xlsx, .xls, and .xlsm files</p>
        <input
          ref={fileInputRef}
          type="file"
          className="file-input"
          accept=".xlsx,.xls,.xlsm"
          onChange={(e) => e.target.files[0] && handleFileUpload(e.target.files[0])}
        />
        <br /><br />
        <button
          className="btn-primary"
          disabled={isAnalyzing}
        >
          {isAnalyzing ? 'Analyzing...' : 'Choose File'}
        </button>
      </div>
      <div className="upload-notes">
        <p><b>Your Data Stays Yours</b></p>
        <p>We never store or retain any files you upload. Your spreadsheet is analyzed securely in real time and permanently deleted immediately after processing. No data is saved or shared.</p>
        <p>If you'd prefer not to upload your file, schedule a secure one-on-one review instead and we'll go through it together. <a target="_top" href="https://calendly.com/the-i3solutions-sales-team/spreadsheet-modernization-review">Schedule here</a>.</p>
        <p><b>Not at your computer?</b> Email us at <a href="mailto:aski3@i3solutions.com">aski3@i3solutions.com</a> and we'll follow up.</p>
      </div>
    </div>
  );
};

export default FileUploadStage;